/* AYUNEL 统一埋点转发器 —— 全站唯一埋点出口
 *
 * 🔴 为什么是外部文件而不是内联:
 *   内联时 trust-band 与 size-diagnosis 各 render 一次 → 同一页面出现 **2 份完全相同的脚本、
 *   共 11.5KB**(2026-08-19 实测)。JS 有幂等守卫所以只执行一次,但那 11.5KB 每次访问都要传输、
 *   且无法被浏览器缓存。改成 asset + defer 后:同 URL 只下载一次、可长期缓存、不阻塞渲染。
 *
 * 详细设计与口径见 snippets/ayunel-track.liquid 的 {% doc %}。
 */
(function () {
  if (window.__aynTrackInit) return;          /* 幂等:重复 render 也只挂一次 listener */
  window.__aynTrackInit = true;

  var QA_KEY = 'ayn_qa';
  var isQA = false;
  try {
    if (/[?&]ayn_qa=1/.test(location.search)) { sessionStorage.setItem(QA_KEY, '1'); }
    isQA = sessionStorage.getItem(QA_KEY) === '1';
  } catch (e) {}

  /* ---------- 出口 1:GA4 + Clarity ---------- */
  try {
    /* 一次性告诉 gtag「用 beacon 发」,而不是每个事件都塞一个同名参数 */
    if (typeof window.gtag === 'function') window.gtag('set', { transport_type: 'beacon' });
  } catch (e) {}

  /* ---------- gtag 就绪队列(新房 2026-09-14 · お気に入り施工单第 6 步;live 版没有这段,cutover 时用新房版整份覆盖)----------
     🔴 原来是「gtag 在才发、不在就丢」。gtag 是 Google 频道的 web pixel 异步挂到 window 上的(不是 gtag.js),
        和本脚本是赛跑:两者常只差 10–30ms,谁先谁后看网络(DEV 实测,办公室网络、全新浏览器上下文 15 次里 1 次 gtag 晚到:
        /pages/wishlist 本脚本 460ms 执行、gtag 476ms 才出现;弱网没测)。晚到的那些访问里,页面一打开就发的
        曝光类事件(ayn_trust_view_* / ayn_size_view / ayn_bundle_view / wishlist_view)只进 dataLayer、进不了 GA4:
        点击率的分母偏低、率虚高。
     规则(调用方不用管,一处出口):
       · gtag 在 → 直接发(队列里还有排着的,先按顺序补完)。
       · 不在 → 进队列:最多 20 条;事件名 + 参数完全相同的只留一条;全页只开一个定时器,每 250ms 查一次、最多 40 次(≈10 秒)。
       · 就绪时 Shopify.customerPrivacy.analyticsProcessingAllowed() **明确返回 false** → 整队丢掉、不补发;
         这个 API 没加载 / 抛错 = 不知道,不当成拒绝(DEV 实测页面上默认没有它)。
       · 超时 → 清空队列、记「已放弃」:本页之后 gtag 没就绪的事件直接丢,不再开定时器。
     dataLayer / clarity 两路不走队列(原样)。上面那句 gtag('set') 保持原样(挪进就绪回调另开卡,先在 DEV 抓包)。 */
  var GQ_MAX = 20, GQ_EVERY_MS = 250, GQ_MAX_TRIES = 40;
  var gq = [], gqKeys = {}, gqTimer = null, gqTries = 0, gqGaveUp = false;

  function gtagReady() { return typeof window.gtag === 'function'; }

  function analyticsRefused() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed() === false;
    } catch (e) { return false; }
  }

  function gqFlush() {
    if (gqTimer) { clearInterval(gqTimer); gqTimer = null; }
    var q = gq;
    gq = []; gqKeys = {};                       /* 先换掉再发:重入 / 再次调用都不会补发第二遍 */
    if (!q.length || analyticsRefused()) return;
    for (var i = 0; i < q.length; i++) {
      try { window.gtag('event', q[i][0], q[i][1]); } catch (e) {}
    }
  }

  function gtagEvent(name, p) {
    if (gtagReady()) {
      if (gq.length) gqFlush();
      try { window.gtag('event', name, p); } catch (e) {}
      return;
    }
    if (gqGaveUp || gq.length >= GQ_MAX) return;
    var key = name + '\n' + JSON.stringify(p);
    if (gqKeys[key]) return;
    gqKeys[key] = 1;
    gq.push([name, p]);
    if (gqTimer) return;                        /* 就绪检查全页只挂一个 */
    gqTries = 0;
    gqTimer = setInterval(function () {
      if (gtagReady()) { gqFlush(); return; }
      if (++gqTries >= GQ_MAX_TRIES) {
        clearInterval(gqTimer); gqTimer = null;
        gq = []; gqKeys = {}; gqGaveUp = true;
      }
    }, GQ_EVERY_MS);
  }

  function send(name, params) {
    var p = {};
    try { for (var k in (params || {})) if (params[k] != null) p[k] = params[k]; } catch (e) {}
    /* ⚠️ 不要把 transport_type 塞进事件参数 —— 实测 payload 里会出现 ep.transport_type=beacon,
       即 gtag 把它当成了自定义参数上报,既白占参数槽、beacon 也未必生效(2026-08-19 复审 B2)。
       正确做法是在 gtag('set') 里设一次,见下方 initTransport()。 */
    if (isQA) p.ayn_qa = 1;                   /* 自测流量打标 → 统计时剔除 */
    try { gtagEvent(name, p); } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, p));
    } catch (e) {}
    if (window.__aynTrackDebug) { try { console.log('[aynTrack]', name, p); } catch (e) {} }
  }
  window.aynTrack = send;

  /* 每 session 只发一次(曝光类用)。
     🔴 return 若写在 try 里,sessionStorage 一抛异常(Safari「全 Cookie 拒否」等)控制流就直落到
        send() —— 「只发一次」静默退化成「每次都发」:_u 失去人数语义、曝光按浏览页数膨胀,
        点击率的分子分母同时虚高且倍数不同,方向不可预测、事后无法校正(2026-08-19 复审 M2)。
        所以:内存去重兜底 + 给这批事件打 ayn_nostore=1,报表里能把它们单独拎出来。 */
  var onceMem = {};
  function sendOnce(name, params) {
    var k = 'ayn_once_' + name;
    if (onceMem[k]) return;
    var stored = false;
    try {
      if (sessionStorage.getItem(k)) { onceMem[k] = 1; return; }
      sessionStorage.setItem(k, '1');
      stored = true;
    } catch (e) {}
    onceMem[k] = 1;
    var p = params || {};
    if (!stored) { p = Object.assign({}, p); p.ayn_nostore = 1; }
    send(name, p);
  }

  /* ---------- 出口 2:cart attributes → 跟随订单进 Shopify ----------
     🔴 绝对不能抢着建购物车。实测(2026-08-19):新客还没有 cart cookie 时,
        /cart/add.js 与 /cart/update.js 并发 → Shopify 各建一个车、后到的 cookie 覆盖前者
        → Δ=150ms 商品丢 3/5、Δ=300ms 丢 4/5。客人看到「已加入购物车」但服务端是空的 = 静默掉单。
        所以:**服务端认的车还不存在就不发**(没有 cart cookie,或 cookie 指着服务端已删的旧车 —— 见下方 checkCart),
        把标记挂起,等购物车真的出现了再补发。
        代价只是「从没加过购物车的客人拿不到订单标记」—— 那种客人本来也没有订单,不影响方案B。 */
  /* 两个计数器必须分开(2026-08-19 上线后自查发现,别再合并):
       retries   = 「等购物车被建出来」的轮询次数 —— 每来一个新标记就该给新预算,重置是对的
       sendFails = 「POST 真的失败」的次数 —— **绝不能重置**,否则服务端持续 5xx 时
                   会变成每秒一发的无限循环(实测模拟:旧版 21 次停,合并计数器后 300 次还在跑) */
  /* seq = 每个 key 的代次。用它区分「这批带的是不是该 key 的最新值」——
     只用「有没有成功 memo」判会毙掉新值:applied=M 发成功后客人改成 L,L 这批若失败,
     旧写法看到 memo 存在就 continue → **L 永久丢失,订单带的是客人放弃的那个码**(复审 C1)。
     代次同时修掉「响应乱序把 memo 写成旧值」的问题。 */
  var pending = {}, pendingSeq = {}, seq = {};
  var okSeq = {};          /* 每个 key 本页最近一次「发成功的最新代次」;== seq[key] = 本页想写的最新值已经落地,记录才可信 */
  var flushTimer = null, retryTimer = null, retries = 0, sendFails = 0;
  var MAX_SEND_FAILS = 5;
  var MEMO_SEP = '\x1f';   /* 发成功记录 = 购物车 token + MEMO_SEP + 值(新房 2026-09-14 · お気に入り施工单第 7 步,见 markCart) */

  /* 当前购物车的 token(cart cookie 里 `?key=` 之前那段车号);没有车 / 空值 → ''。
     🔴 必须要求**非空 token**。只写 `cart=` 的话,一个空值 cookie(cart=;)也会被判成
       「购物车已建成」→ 守卫放行 → 埋点又去抢建车 → 掉单竞态原样复活。
       字符集按 base64url 放宽到含 - 和 _,否则 token 里早早出现 - 就会被误判成「车还没建」,标记永远发不出(复审 D1)。
     DEV 实测(2026-09-14):cookie 值 = 24 位车号 + `%3Fkey%3D` + 32 位(共 65 位);正则截到的是那 24 位车号,
       同一辆车再加购不变,清掉 cookie 再加购(新车)就变。 */
  function cartToken() {
    try {
      var m = /(^|;\s*)cart=[A-Za-z0-9_-]{20,}/.exec(document.cookie);
      return m ? m[0].slice(m[0].indexOf('cart=') + 5) : '';
    } catch (e) { return ''; }
  }

  function hasCart() { return !!cartToken(); }

  /* ---------- 核车:cookie 在 ≠ 服务端还认这辆车(新房 2026-09-14 · お気に入り施工单第 7 步对抗审后补)----------
     🔴 hasCart() 只看 cookie 的格式。「cookie 还在、服务端的车已经没了」是常态:cart cookie 实测 91 天才过期,
        而没结账的车创建后 30 天内就被 Shopify 过期删掉(文档;结账完成也删车)。这时 POST /cart/update.js 照样 200、
        还会**新建一辆车并下发新 cookie** = 又回到上面那条「抢建购物车」:客人的 /cart/add.js 带着同一个旧 cookie 同时在途
        → 各建一辆车、后回来的 cookie 盖掉先回来的 → 商品丢了,车上的标记还写着命中。
        DEV 实测(旧 cookie = 格式合法的随机车号):商品页点心后 250–700ms 加购 5/5 最终车里 0 件(点心约 0.7 秒后打标,
        心和「カートに追加」挨在一行);尺码诊断「按推荐尺码加购」同一时序 2/2 丢(点完加购钮就发 applied → 700ms 后打标)。
     所以:某个车号在本页第一次写之前,先 GET /cart.js 核一次 —— 返回的 token(`车号?key=…`)里的车号 == cookie 车号,
        才算服务端认这辆车;不一致 = 旧车,当作没车:不发,等真正的加购把新车建出来(cookie 换了新车号就再核)。
        DEV 实测:GET /cart.js 不建车、不设 cookie(没 cookie / 旧 cookie 都回一个 32 位随机 token、0 件)。
        核的结果记在「发 GET 时的那个车号」上(认 / 不认各记一个),本页不重复核;核车失败(网络 / 5xx)= 不知道车在不在 → 不发,
        失败次数与写失败共用 sendFails 上限。markCart 一来就先核(趁 700ms 节流),节流到点时通常已核完。
     已知边界(没再防):① 本页核过「认」之后车才被删(别的标签页结账完成等)→ 本页仍当它在,要撞上还得正好同时在加购;
        ② 跳页那一刻(pagehide)车号还没核完 → 这页的标记不发(不建车优先于不丢标)—— 只剩「第一次打标时就带着的车号」这一种,
           本页后来新出现的车号当场认下、跳页照发(见下方 tok0,2026-09-14 现网实测复审补);
        ③ Shopify 若改了 /cart.js 的 token 形态(车号不再是 token 的开头),会一律判「不认」、标记全部停发 ——
           宁可丢标不丢单;DEV 走查 wishlist_walk_newhouse.py 的「打标」段会红。 */
  var cartOk = '', cartBad = '', checking = false;
  /* 本页第一次打标时的车号(第一次 markCart 时记下)。之后 cookie 换成的别的车号只可能来自某个写车请求的回包
     (客人加购 / 别的脚本写车)= 服务端刚下发的车,不必再 GET 核、当场认下。
     为什么(2026-09-14 现网实测复审,Codex + 三路审查员一致指出;现网真浏览器「加购回包 0.2 秒后跳购物车页」只核车版 1/2 丢标记、补后 0/2):
     不这样的话新车号也要等 GET 核完才发 —— 客人加购后马上跳页、或打标 20 秒后才用普通加购键加购再跳页,
     这页的标记就发不出去(跳页时 GET 回包没人接),而 live 旧版在跳页那一刻用 keepalive 发得出去 = 标记倒退。
     只有「第一次打标时就带着的车号」才可能是服务端已删的旧车,才需要核。守卫:tests/test_theme_track_ready_queue.py ㉑㉒。 */
  var tok0 = null;

  /* 服务端可能认的车:有 cookie,且不是本页核过「不认」的那个车号 */
  function cartUsable() { var t = cartToken(); return !!t && t !== cartBad; }

  /* ---------- 改车请求在途时不写(新房 2026-09-14 补跑框 · 交棒档 §三-3 DEV 实测)----------
     🔴 有效的车上,官方「カートに追加」的 /cart/add.js 还在途时再发一次 /cart/update.js(只改属性),Shopify 偶尔把刚加的那件弄丢:
        两个请求都回 200、客人看到「已加入」,车里却少一件。DEV 实测(scratchpad heart_add_race.py,同一辆车 40 次「点心后 300 / 600ms 加购」):
        丢件的那几次都是 add 先发、update 后发、两个同时在途;反过来丢的是标记(wishlist-src/README §六-4b)。
     所以:页面上有任何改车请求在途 —— 官方加购 / 购物车改数量·删除 / 2点セット / 收藏页加购都先派发 shopify:cart:lines-update
        (带 promise)再发请求(Horizon 4.1.4 product-form.js 实读;折扣 discount-update 同理)—— 这里不发,等它们都结算、再照常节流 700ms 才发
        (和结算后收藏重算的那次合成一发,也给赠品同步留出读车的时间);每个最多等 20 秒(2点セット:等别人 ≤10 秒 + 自己请求 ≤10 秒),
        promise 永不结算也不会把标记卡死。
     赠品同步(ayunel-gift-sync-v2.js)是改完车才派发事件、它自己的请求在途时事件看不见 —— 但它干活的整段时间 body 上挂着
        ayn-gift-syncing(它用来锁购物车 +/−/削除 的那个 class):挂着就先不发,每 250ms 再看一次,最多等 20 秒(补跑框独立审查员指出:
        客人加购一结算,赠品同步紧接着读车、加赠品,我们结算后立刻发的那一发正好和它撞上)。
     跳页 / 切后台那一刻若还有改车在途(含赠品同步)→ 这一次不发(宁可丢标记,不冒丢商品的险)。
     反过来「我们先发、别的组件后开始改车」挡不住(客人点加购没法等我们):这发在途时收到改车事件,成功也不记发成功记录,
        改车结算后照最新值再发一次 —— 服务端若拿改车那一刻的旧车盖掉了这批属性,能补回来。
     自己的 /cart/update.js 同一时刻也只让一发在途(补跑 Codex C3):两发同时在途、服务端后发的先落地 → 车上留旧值,
        本机记录却是新值、之后同值不补写。在途那发成功回来再发排着的最新值;最多等它 10 秒;跳页 / 切后台例外、照发
        (页面要走了等不到;两发都只改属性、不碰商品行)。
     没覆盖到的:积分取消那一处 /cart/update.js(snippets/points-redeem.liquid)不派发事件。守卫 tests/test_theme_track_ready_queue.py ⑦(桩 ㉓–㉘)。 */
  var CART_BUSY_MAX_MS = 20000, OWN_MAX_MS = 10000, GIFT_POLL_MS = 250, THROTTLE_MS = 700;
  var GIFT_BUSY_CLASS = 'ayn-gift-syncing';
  var cartBusyN = 0, waitCartIdle = false, giftPolls = 0;   /* 别的组件在途的改车请求数;有标记在等它们结算;等赠品同步已看了几次 */
  var sending = false, sendGen = 0, waitOwn = false, dirtySend = false;   /* 自己的 /cart/update.js 在途;有标记在等它回来;它在途时别的组件开始改车了 */

  /* 节流:从现在起 700ms 后发(期间再来的标记合进同一发) */
  function armFlush() {
    if (flushTimer) clearTimeout(flushTimer);
    flushTimer = setTimeout(flushCart, THROTTLE_MS);
  }

  function giftSyncing() {
    try { return !!(document.body && document.body.classList.contains(GIFT_BUSY_CLASS)); } catch (e) { return false; }
  }

  /* ---------- 别的标签页改车在途时也不写(2026-10-05 推荐位追踪双脑复审 Codex P0)----------
     cartBusyN 只看得见本页的改车。客人开着两个标签页:A 页加购成功、700ms 后写标记,这期间 B 页点了加购还没回来
     → A 的 /cart/update.js 与 B 的 /cart/add.js 同时在途 = 9/14 丢件的条件(learning-inbox 20260914-200821)。
     所以:本页每个改车请求在途时在 localStorage 挂一块「ayn_cbusy_<本页编号>_<序号> = 截止时刻」(最多 20 秒),结算就摘;
     键每次都新,不续期复用 —— 别的页清理过期牌子时不会误删刚挂上的新牌(10/5 第三轮 Codex P1)。
     写车前看见别的页挂着(没过截止时刻)→ 每 250ms 再看,**不设总等待上限**(牌子自己 20 秒过期,不会永远卡住;
     设上限的话别的页连续改车超过上限就会放行并发,10/5 第三轮 Codex P1);跳页那一刻这一次不发。
     过了截止时刻的牌子(那页崩了 / 关了)顺手清掉。存储不可用 = 看不见别的页(退回原来只防本页)。
     残余:B 页的加购在 A 的写车已经发出之后才开始 —— 那是「我们先发、改车后到」,丢的是标记不是商品(9/14 实测),有 dirtySend 补发兜底的只限本页。 */
  var XTAB_PREFIX = 'ayn_cbusy_', XTAB_ID = String(Math.random()).slice(2, 10) + String(Date.now() % 1e6), xtabSeq = 0;
  function xtabOn() {
    var k = XTAB_PREFIX + XTAB_ID + '_' + (++xtabSeq);
    try { window.localStorage.setItem(k, String(Date.now() + CART_BUSY_MAX_MS)); } catch (e) {}
    return k;
  }
  function xtabOff(k) { try { window.localStorage.removeItem(k); } catch (e) {} }
  function otherTabBusy() {
    try {
      var ls = window.localStorage, now = Date.now(), busy = false, dead = [];
      for (var i = 0; i < ls.length; i++) {
        var k = ls.key(i);
        if (!k || k.indexOf(XTAB_PREFIX) !== 0 || k.indexOf(XTAB_PREFIX + XTAB_ID + '_') === 0) continue;
        if (Number(ls.getItem(k)) > now) busy = true; else dead.push(k);
      }
      dead.forEach(function (k) { try { ls.removeItem(k); } catch (e) {} });
      return busy;
    } catch (e) { return false; }
  }

  function onCartChange(e) {
    var p = e && e.promise;
    if (!p || typeof p.then !== 'function') return;
    if (sending) dirtySend = true;
    var done = false;
    cartBusyN++;
    var xk = xtabOn();
    var release = function () {
      if (done) return;                          /* 结算与 20 秒兜底只减一次(减两次 = 计数变负、之后的在途全看不见) */
      done = true;
      cartBusyN--;
      xtabOff(xk);
      if (cartBusyN === 0 && waitCartIdle) { waitCartIdle = false; armFlush(); }
    };
    try { p.then(release, release); } catch (err) { release(); }
    setTimeout(release, CART_BUSY_MAX_MS);
  }
  try {
    document.addEventListener('shopify:cart:lines-update', onCartChange, true);
    document.addEventListener('shopify:cart:discount-update', onCartChange, true);
  } catch (e) {}

  /* 自己那一发结束(回包到了 / 等满 10 秒):gen 不是最新那发就不动(别把后来那发的「在途」清掉) */
  function ownDone(gen) {
    if (gen !== sendGen || !sending) return false;
    sending = false;
    return true;
  }

  function checkFailed() { checking = false; sendFails++; scheduleRetry(); }

  function checkCart() {
    var tok = cartToken();
    if (!tok || tok === cartOk || tok === cartBad || checking) return;
    checking = true;
    try {
      fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (r) { return r && r.ok ? r.json() : null; })
        .then(function (c) {
          if (!c || typeof c.token !== 'string') { checkFailed(); return; }
          checking = false;
          if (c.token.split('?')[0] === tok) cartOk = tok; else cartBad = tok;
          if (!flushTimer) flushCart();          /* 节流已到点、在等核车 → 现在发;还在节流里就交给定时器 */
        })
        .catch(checkFailed);
    } catch (e) { checkFailed(); }
  }

  function markCart(key, val) {
    try {
      /* memo 只在**发送成功后**才写(见 flushCart),所以这里读到就代表真的发出去过。
         🔴 只有「同一辆车上发成功过同一个值」才跳过(新房 2026-09-14 · お気に入り施工单第 7 步)。
            原来只比值、不看是哪辆车:下单后 / cookie 过期 / 清掉 cookie 换了新车,sessionStorage 里的旧记录还在
            → 新车上同值一律被当成「发过了」→ 新车的订单带不上标记,零报错(方案 §2.3 订单打标行,Codex Node 模型复现)。
            旧格式(只有值)的记录天然对不上,每个 key 最多补发一次。
         🔴 而且本页还有更新的值在排队 / 在途时(seq ≠ okSeq),记录就不代表车上最后会是什么,不许拿它跳过:
            车上是 1|A(记录 1|A)→ 客人 700ms 内把心点掉又点回 → '' 排着队、1|A 被记录判成「发过了」跳过
            → 最后发出去的是 '',车上的收藏标记被删掉(第 7 步 _ayn_wl 是第一个会来回变值的 key,原来的标记都只写 '1')。 */
      if (seq[key] === okSeq[key] && sessionStorage.getItem('ayn_ca_' + key) === cartToken() + MEMO_SEP + String(val)) return;
    } catch (e) {}
    if (tok0 === null) tok0 = cartToken();                        /* 见 tok0 */
    seq[key] = (seq[key] || 0) + 1;
    pending[key] = String(val);
    pendingSeq[key] = seq[key];
    armFlush();                                                   /* 节流:连点也只发一次 */
    checkCart();                                                  /* 趁节流先核车(核过 / 没 cookie / 正在核 → 什么都不做) */
  }

  function scheduleRetry() {
    if (retryTimer) return;
    if (sendFails >= MAX_SEND_FAILS) return;     /* 发送侧连续失败太多 → 认输,别再打服务端 */
    /* 🔴 每启动一轮新轮询都给新预算。原来 retries 只增不减:客人点了标签、20 秒内没加购
       → 额度耗尽 → 之后**即使真的加了购物车**,scheduleRetry 第一行就 return,
       标记永久丢失且无任何报错(2026-08-19 复审 H2)。 */
    retries = 0;
    retryTimer = setInterval(function () {
      retries++;
      if (cartUsable()) { clearInterval(retryTimer); retryTimer = null; flushCart(); }   /* 旧车号不算:等 cookie 换成新车 */
      else if (retries >= 20) { clearInterval(retryTimer); retryTimer = null; }   /* ~20s 后放弃 */
    }, 1000);
  }

  /* urgent = 跳页 / 切后台那一刻(flushNow):自己上一发还在途也照发;别的组件改车在途时照样不发。定时器 / 重试 / 核车回来调用时不带参数。 */
  function flushCart(urgent) {
    if (flushTimer) clearTimeout(flushTimer);    /* 被重试 / 核车 / 结算提前调到时,别留一个孤儿定时器把下一轮节流缩短 */
    flushTimer = null;
    var n = 0; for (var _k in pending) n++;
    if (!n) return;
    if (cartBusyN > 0) { waitCartIdle = true; return; }   /* 🔴 别的组件改车在途(见上方「改车请求在途时不写」)→ 等它结算 */
    if (otherTabBusy()) {                        /* 🔴 别的标签页改车在途 → 这一次不发(跳页 / 切后台那一刻也是),250ms 后再看;
                                                    不设总上限(牌子自己会过期);切后台时也要挂上,否则切回来后排着的标记一直不发(10/5 第四轮复审) */
      flushTimer = setTimeout(flushCart, GIFT_POLL_MS);
      return;
    }
    if (giftSyncing() && giftPolls * GIFT_POLL_MS < CART_BUSY_MAX_MS) {   /* 🔴 赠品同步在改车 → 过一会儿再看(跳页那一刻这一次就不发了) */
      giftPolls++;
      flushTimer = setTimeout(flushCart, GIFT_POLL_MS);
      return;
    }
    giftPolls = 0;
    if (sending && urgent !== true) { waitOwn = true; return; }   /* 🔴 自己上一发还在途 → 它回来再发最新值 */
    if (!hasCart()) { scheduleRetry(); return; }   /* 🔴 车还没建 → 不抢,pending 原样留着 */
    var tok = cartToken();
    if (tok === cartBad) { scheduleRetry(); return; }   /* 🔴 cookie 指着服务端已删的旧车 = 同「没车」,不发 */
    if (tok !== cartOk) {                                /* 这辆车本页还没核过: */
      if (tok0 !== null && tok !== tok0) cartOk = tok;   /*   第一次打标之后新出现的车号 = 服务端刚下发的,当场认下接着发 */
      else { checkCart(); return; }                      /*   第一次打标时就带着的车号 → GET 核,核完回来再发 */
    }

    /* 失败回填:① pending 里已有更新值 → 别盖;② 该键已有成功 memo(说明更新值已落地)→ 别退回。
       没有 ② 时会出现:applied=L 先发成功、applied=M 的旧请求后失败回填 → 重发把订单标记改回 M。 */
    /* 返回「真正回填了几个**当前代次**的 key」。
       🔴 这个返回值决定要不要消耗 sendFails 预算:过期批次的失败不该算数。
          否则客人连改 6 次尺码、前 5 个在飞的旧请求陆续失败 → 预算被过期批次吃光(6/5),
          **最新那个值失败一次就再也不重试**(node 模拟实测:修前最新值被拒重试,修后 sendFails=1 仍在重试)。
          (2026-08-20 双脑复审 Codex ③,主脑用异步模型模拟复现属实。) */
    function restore(src, srcSeq) {
      var restoredCurrent = 0;
      for (var rk in src) {
        if (rk in pending) continue;              /* 队里已有更新值 → 别盖 */
        if (srcSeq[rk] !== seq[rk]) continue;     /* 这批已过时(更新的值另有一批)→ 别退回 */
        pending[rk] = src[rk]; pendingSeq[rk] = srcSeq[rk];
        restoredCurrent++;
      }
      return restoredCurrent;
    }
    var attrs = pending, attrsSeq = pendingSeq;
    pending = {}; pendingSeq = {};
    recGuard(tok, attrs);                        /* 推荐 / 套装的值算完后换了车 → 这一发不带它(见下方推荐位追踪) */
    var nLeft = 0; for (var _k2 in attrs) nLeft++;
    if (!nLeft) return;
    /* 发之前记下这批写进的是哪辆车:回包到时 cookie 可能已换成新车,记录要记「发往的那辆」,不能记回包那一刻的 */
    var sentToken = tok;
    /* 🔴 显式写 '' 而不是「不写」—— Shopify 用空字符串删除该 attribute。
       否则 QA 标记会一直挂在这辆车上(车没结账最长约 30 天才被 Shopify 过期,cart cookie 本身实测 91 天):自测过的浏览器之后下的**真实订单**
       会被报表当成自测单剔掉;反向若 ?ayn_qa=1 流进广告 URL,真客人的车会被永久打标。 */
    attrs['_ayn_qa'] = isQA ? '1' : '';
    seq['_ayn_qa'] = (seq['_ayn_qa'] || 0) + 1; attrsSeq['_ayn_qa'] = seq['_ayn_qa'];
    var gen = ++sendGen;
    sending = true;
    dirtySend = false;
    /* 回包一直不来(网络挂住):最多等 10 秒就不再等它,排着的值照发(不许把标记永远卡住) */
    setTimeout(function () { if (ownDone(gen) && waitOwn) { waitOwn = false; flushCart(); } }, OWN_MAX_MS);
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
        keepalive: true
      }).then(function (r) {
        var mine = ownDone(gen);
        if (r && r.ok) {
          retries = 0; sendFails = 0;         /* 成功一次,两个预算都还回去 */
          if (mine && dirtySend) {
            /* 这发在途时别的组件开始改车了(我们先发、改车后到):服务端可能拿改车那一刻的旧车盖掉了这批属性 →
               这批不记发成功,放回待发,等改车结算后照最新值再发一次(同一辆车同值也发) */
            dirtySend = false; waitOwn = false;
            restore(attrs, attrsSeq);
            armFlush();
            return;
          }
          /* 成功才记 memo。之前在排队时就记,一旦请求失败标记会永久丢失且不重试 */
          /* 只有「这批仍是该 key 的最新代次」才写 memo,否则乱序响应会把 memo 写成旧值,
             之后客人再选回那个旧值时 markCart 会误判「已发过」而永不发送 */
          for (var k in attrs) {
            if (attrsSeq[k] === seq[k]) {
              okSeq[k] = seq[k];
              try { sessionStorage.setItem('ayn_ca_' + k, sentToken + MEMO_SEP + attrs[k]); } catch (e) {}
            }
          }
          if (waitOwn && !sending) { waitOwn = false; flushCart(); }   /* 在途时排上的最新值:现在发 */
        } else {
          if (mine) waitOwn = false;            /* 失败:排着的值与回填的一起交给重试(受 sendFails 上限管),不在这里连发;
                                                   过期那发(10 秒兜底后才回来)的失败不许清掉后来那发的排队标志 */
          if (restore(attrs, attrsSeq) > 0) sendFails++;   /* 只有当前代次的失败才消耗预算 */
          scheduleRetry();
        }
      }).catch(function () {
        if (ownDone(gen)) waitOwn = false;
        if (restore(attrs, attrsSeq) > 0) sendFails++;
        scheduleRetry();
      });
    } catch (e) {
      restore(attrs, attrsSeq);
      ownDone(gen);
      waitOwn = false;
      scheduleRetry();          /* 与两个异步失败分支保持一致,否则同步抛错时标记永不重发 */
    }
  }

  /* 跳页/切后台时立刻把待发的标记冲出去。
     keepalive 只能保「已在飞的请求飞完」,保不了「还没触发的 700ms 定时器」—— 那才是真正会丢的。 */
  function flushNow() {
    if (flushTimer) { clearTimeout(flushTimer); flushTimer = null; }
    flushCart(true);
  }
  try {
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flushNow();
    });
    /* 🔴 捕获阶段注册(第三个参数 true),让它排在同一个 pagehide 里所有冒泡监听之前(2026-09-14 DEV 实测定位):
       Horizon 4.1.4 的 scroll-container.js 在 pagehide 里 history.replaceState() 存滚动位置,它之后发的 keepalive 请求
       在「脚本改地址 / 地址栏」式跳页时被浏览器取消(商品卡片就是 location.href 跳页;点链接不受影响)→ 标记丢。
       抢在它前面发就能落地(实测)。守卫 tests/test_theme_track_ready_queue.py ⑥。 */
    window.addEventListener('pagehide', flushNow, true);
  } catch (e) {}

  window.aynMarkCart = markCart;

  /* ---------- 推荐位追踪 + 套装订单标记(2026-10-05 · 05-output/2026-10-05-推荐位追踪方案-客人点击与成交.md v2)----------
     🔴 订单标记不在点击那一刻写:还没加购的客人没有购物车,标记只能挂在当页内存里,一跳页就没了;
        已有购物车也要先核车、和跳页赛跑。所以:
        ① 点推荐卡片 → 只把「目标、格位、来源、日期」存进 localStorage(待确认 p,按目标 + 来源存多条:多标签页各点各的不串);
        ② 落地页(网址带 pr_rec_pid / pr_ref_pid、document.referrer 是本站)→ 与待确认按目标 + 来源配对,确认成一条记录;
           没配上(中键开新标签页不触发 click 等)→ 只有「新打开」的页面才记一条格位 0;刷新 / 返回 / 恢复标签页一律不新增
           (否则下单作废后再按返回,旧点击会以格位 0 复活进下一单 —— 双脑复审 10/5 两路都指出);
        ③ **只在本页改车成功后**(shopify:cart:lines-update 结算且没出错 / 套装加购成功)把记录合成一个值经 aynMarkCart 写 _ayn_rec。
           🔴 页面打开时不写:那一刻看不见别的标签页正在进行的加购(cartBusyN 只管本页),先发的 /cart/update.js 与它同时在途
              就是 9/14 丢件的条件(learning-inbox 20260914-200821;双脑复审 10/5 Codex P0)。与收藏标记 _ayn_wl 同一做法。
              代价:点过推荐、之后一次都没改车就结账的那单不带标记(它买的也不是推荐目标);「推荐目标成交」不受影响(买目标必经加购)。
     记录合并:按目标商品去重(留最近一次点击)、最多 8 条,压缩成「目标:格位:来源:日期」逗号分隔(约 300 字);7 天前的作废。
     🔴 记录绑定车号,防止旧点击污染下一单:落地时不绑(c=''),第一次改车成功时绑到当时的车(此刻服务端一定认这辆车);
        之后车号一变(下单后换新车 / cookie 清掉)绑旧车的一律作废 —— 不管发没发出去(宁可漏标,不污染下一单)。
        待发的值记下「算给哪辆车」(recValTok),发出前车已经换了就丢掉,不把旧车的值发给新车。
     只经 aynMarkCart 写车:节流、没车不抢建、改车在途不写、跳页那一刻同步补发都沿用上面的出口 2,这里不碰 /cart/update.js。
     GA4:ayn_rec_view(推荐区真的有商品、进入屏幕,每页每个推荐区只记一次)/ ayn_rec_click(每次点击)/
          ayn_rec_click_pv(每页每个推荐区第一次点击,点击率分子;分母 = ayn_rec_view,同为「页面浏览」单位)。
          参数 ayn_rec_source / ayn_rec_target / ayn_rec_slot / ayn_rec_date(JST 年月日 YYMMDD)。
     localStorage 读或写失败(Safari 全拒否 / 配额满)→ 本页起只用内存:落地页那一条照写,跨页记录没有。全部 try/catch,坏了不影响下单。
     守卫 tests/test_theme_rec_tracking.py(跑真代码,桩 tests/_rec_track_harness.mjs)。 */
  var REC_LS = 'ayn_rec_v1', REC_KEY = '_ayn_rec', BUN_KEY = '_ayn_bundle';
  var REC_MAX = 8, BUN_MAX = 8, PEND_MAX = 10, REC_TTL_MS = 7 * 864e5, PEND_TTL_MS = 30 * 6e4;
  var recMem = null, recMemOnly = false;   /* 存储读 / 写失败过 → 本页只用内存 */
  var recValTok = {};                      /* 待发的推荐 / 套装值是按哪辆车算的 */
  var recViewed = {}, recClickedPv = {};
  var recRelease = function () {};             /* 曝光记过后停掉该推荐区的观察器(observeRec 里赋值) */

  function jstDay(ms) {
    var d = new Date(ms + 9 * 36e5);
    return String(d.getUTCFullYear()).slice(2) + ('0' + (d.getUTCMonth() + 1)).slice(-2) + ('0' + d.getUTCDate()).slice(-2);
  }
  function isPid(v) { return typeof v === 'string' && /^\d{1,20}$/.test(v); }
  function recStr(e) { return e.g + ':' + e.s + ':' + e.f + ':' + e.d; }
  function fresh(t, now, ttl) { return typeof t === 'number' && now - t <= ttl && t - now <= 6e4; }

  function recLoad() {
    var s = null;
    if (!recMemOnly) {
      try { var raw = window.localStorage.getItem(REC_LS); if (raw) s = JSON.parse(raw); } catch (e) { recMemOnly = true; }
    }
    if (recMemOnly) s = recMem;
    if (!s || typeof s !== 'object') s = {};
    if (!Array.isArray(s.r)) s.r = [];
    if (!Array.isArray(s.b)) s.b = [];
    if (!Array.isArray(s.p)) s.p = [];
    if (!s.w || typeof s.w !== 'object') s.w = {};
    return s;
  }
  function recSave(s) {
    recMem = s;
    if (recMemOnly) return;
    try { window.localStorage.setItem(REC_LS, JSON.stringify(s)); } catch (e) {
      recMemOnly = true;
      try { window.localStorage.removeItem(REC_LS); } catch (e2) {}   /* 旧快照留着,下一页会把本页已作废 / 已绑车的记录当成新的(10/5 补审 Codex P2) */
    }
  }

  /* 车号绑定 + 过期 + 去重(idOf = 去重键),返回留下的记录(新的在前,最多 max 条)。cur = 刚改车成功的那辆车 */
  function recBind(list, now, idOf, max, cur) {
    var out = [], seen = {};
    list.sort(function (a, b) { return ((b && b.t) || 0) - ((a && a.t) || 0); });
    for (var i = 0; i < list.length && out.length < max; i++) {
      var e = list[i];
      if (!e || !fresh(e.t, now, REC_TTL_MS)) continue;
      var id = idOf(e);
      if (!id || seen[id]) continue;
      if (e.c && e.c !== cur) {
        if (!e.q || now - e.t > 12e4) continue;    /* 绑的是别的车(上一单 / 已清掉的车)→ 作废 */
        e.c = '';                                  /* 点击后 2 分钟内、核车还没回来就换了车:这是这次新点的,跟新车(10/6 最终复审 Codex P1)。
                                                      超过 2 分钟还挂着 q = 核车失败 / 秒退没回来 → 按旧记录作废,宁可漏标不污染下一单(10/6 快审两路 P1) */
      }
      e.c = cur;
      seen[id] = 1;
      out.push({ g: e.g, s: e.s, f: e.f, d: e.d, m: e.m, t: e.t, c: e.c });
    }
    return out;
  }
  function recId(e) { return isPid(e.g) ? e.g : ''; }
  function bunId(e) { return typeof e.m === 'string' ? e.m : ''; }

  function recWriteKey(s, key, val, cur) {
    if (val) { s.w[key] = cur; recValTok[key] = cur; markCart(key, val); return; }
    if (s.w[key] === cur) { recValTok[key] = cur; markCart(key, ''); }   /* 这辆车上写过、现在全过期了 → 清掉;没写过就不多发一次。
                                                                           s.w 留着:清除失败时下次改车还会再清,成功后同车同值 markCart 自己跳过(10/5 第四轮 Codex P1) */
    else if (s.w[key]) delete s.w[key];                                 /* 写过的是别的车(上一单)→ 这条记录没用了 */
  }

  /* 只在改车成功之后调(此刻 cookie 里的车服务端一定认) */
  function recSync() {
    try {
      var cur = cartToken();
      if (!cur || cur === cartBad) return;
      var now = Date.now(), s = recLoad();
      s.r = recBind(s.r, now, recId, REC_MAX, cur);
      s.b = recBind(s.b, now, bunId, BUN_MAX, cur);
      s.p = s.p.filter(function (p) { return p && fresh(p.t, now, PEND_TTL_MS); });
      recWriteKey(s, REC_KEY, s.r.map(recStr).join(','), cur);
      recWriteKey(s, BUN_KEY, s.b.map(bunId).join(','), cur);
      recSave(s);
    } catch (e) {}
  }

  /* flushCart 发之前调:推荐 / 套装的值不是按这辆车算的(算完之后换了车)→ 这一发不带它,等下一次改车按新车重算 */
  function recGuard(tok, attrs) {
    try {
      [REC_KEY, BUN_KEY].forEach(function (k) {
        if (!(k in attrs)) return;
        if (recValTok[k] !== tok) { delete attrs[k]; return; }
        /* 同一辆车:按此刻的共享记录重算再发 —— 别的标签页可能刚写过更新的值,失败重试也不许拿旧快照盖回去(10/5 第四轮 Codex P1) */
        var s = recLoad(), now = Date.now(), list = k === REC_KEY ? s.r : s.b, out = [], seen = {};
        list = list.slice().sort(function (a, b) { return ((b && b.t) || 0) - ((a && a.t) || 0); });
        for (var i = 0; i < list.length && out.length < (k === REC_KEY ? REC_MAX : BUN_MAX); i++) {
          var e = list[i];
          if (!e || e.c !== tok || !fresh(e.t, now, REC_TTL_MS)) continue;
          var id = k === REC_KEY ? recId(e) : bunId(e);
          if (!id || seen[id]) continue;
          seen[id] = 1;
          out.push(k === REC_KEY ? recStr(e) : e.m);
        }
        if (out.length || (s.w && s.w[k] === tok)) attrs[k] = out.join(',');
        else delete attrs[k];   /* 算出空值、共享记录又没有「这辆车写过」= 记录被别的页清掉了(存储写满):这一发不带它 ——
                                   不发空值清掉车上的,也不拿旧快照盖别的页刚写的新值(10/6 最终复审两路) */
      });
    } catch (e) {}
  }

  function sameSiteReferrer() {
    try {
      var r = document.referrer || '';
      var o = location.protocol + '//' + location.host + '/';
      return !!location.host && r.indexOf(o) === 0;
    } catch (e) { return false; }
  }

  /* 这一页是不是「新打开」的(不是刷新 / 返回前进 / 恢复);拿不到 = 不知道 → 当作不是 */
  function freshNavigation() {
    try {
      var n = performance.getEntriesByType('navigation')[0];
      return !!n && n.type === 'navigate';
    } catch (e) { return false; }
  }

  function recLanding() {
    try {
      var q = location.search || '';
      var mr = /[?&]pr_rec_pid=(\d{1,20})(&|$)/.exec(q), mf = /[?&]pr_ref_pid=(\d{1,20})(&|$)/.exec(q);
      if (!mr || !mf || !sameSiteReferrer()) return;
      var g = mr[1], f = mf[1], now = Date.now(), s = recLoad(), hit = -1;
      for (var i = 0; i < s.p.length; i++) {
        var p = s.p[i];
        if (p && p.g === g && p.f === f && fresh(p.t, now, PEND_TTL_MS) && (hit < 0 || p.t > s.p[hit].t)) hit = i;
      }
      var e;
      if (hit >= 0) {
        var m = s.p.splice(hit, 1)[0];
        e = { g: g, s: String(m.s || '0'), f: f, d: m.d || jstDay(now), t: m.t };
      } else {
        if (!freshNavigation()) return;            /* 刷新 / 返回 / 恢复标签页:不是新点击 */
        e = { g: g, s: '0', f: f, d: jstDay(now), t: now };   /* 新打开但没有点击记录(中键 / 右键菜单开新标签页):格位 0,来源按网址 */
      }
      var cur = cartToken(), same = null;
      for (var k = 0; k < s.r.length; k++) if (s.r[k] && s.r[k].g === g && cur && s.r[k].c === cur) same = s.r[k];
      if (same) { same.s = e.s; same.f = e.f; same.d = e.d; same.t = e.t; same.q = 1; }   /* 同款、车还是那辆:原地更新,保留绑定(10/5 补审 Codex P1);q = 核车中 */
      else s.r.unshift({ g: e.g, s: e.s, f: e.f, d: e.d, t: e.t, c: '' });
      recSave(s);
      if (cur) recVerifyLanding(cur, g, e.t);
    } catch (e) {}
  }

  /* 落地这一条(g + t)核 cookie 里的车 tok:GET /cart.js(只读、不建车、不设 cookie —— 与 checkCart 同)。
     服务端认 → 未绑定的当场绑上(客人没加购就结账,这条随这一单作废,不跟进下一单 —— 第四轮两路复审);
     不认(下单后 / 过期的旧车)→ 绑在它上面的解绑,跟下一辆车(第三轮 Codex P2);读失败 = 不知道 → 照旧。 */
  function recVerifyLanding(tok, g, t) {
    try {
      fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (r) { return r && r.ok ? r.json() : null; })
        .then(function (c) {
          if (!c || typeof c.token !== 'string') { recUnq(g, t); return; }   /* 读失败 = 不知道:只摘 q,绑定不动 */
          var alive = c.token.split('?')[0] === tok, s = recLoad(), ch = false;
          s.r.forEach(function (e) {
            if (!e || e.g !== g || e.t !== t) return;
            if (e.q) { delete e.q; ch = true; }
            if (alive && !e.c) { e.c = tok; ch = true; }
            else if (!alive && e.c === tok) { e.c = ''; ch = true; }
          });
          if (ch) recSave(s);
        })
        .catch(function () { recUnq(g, t); });
    } catch (e) {}
  }
  function recUnq(g, t) {
    try {
      var s = recLoad(), ch = false;
      s.r.forEach(function (e) { if (e && e.g === g && e.t === t && e.q) { delete e.q; ch = true; } });
      if (ch) recSave(s);
    } catch (e) {}
  }

  function recSecId(sec) { return (sec && (sec.id || sec.getAttribute('data-section-id'))) || 'rec'; }
  function recSrc(sec) { var v = sec && sec.getAttribute('data-product-id'); return isPid(v) ? v : ''; }

  /* 曝光去重:每页每个推荐区一次(内存;不用 sendOnce —— 它按事件名 + session 去重,会把第二页起的曝光全吞掉) */
  function recViewSend(sec) {
    if (!sec) return;
    var id = recSecId(sec);
    if (recViewed[id]) return;
    try { if (!sec.querySelector('[data-ayn-rec-slot]')) return; } catch (e) { return; }
    recViewed[id] = 1;
    send('ayn_rec_view', { ayn_rec_source: recSrc(sec), ayn_rec_date: jstDay(Date.now()) });
    try { recRelease(sec); } catch (e) {}   /* 不管是观察器记的还是点击补记的,记过就停(10/6 最终复审 Codex P2) */
  }

  function recClick(e) {
    try {
      var t = e && e.target;
      if (!t || !t.closest) return;
      var item = t.closest('[data-ayn-rec-slot]');
      if (!item) return;
      /* 收藏心形 / 色块 / 轮播箭头 / 按钮 / 输入框:不跳页,不算点击(与 product-card.js navigateToProduct 的排除同口径) */
      if (t.closest('button, input, label, select, textarea, [tabindex="1"], .ayunel-card-heart')) return;
      var g = item.getAttribute('data-ayn-rec-pid') || '';
      if (!isPid(g)) return;
      var sec = item.closest('product-recommendations');
      var slot = item.getAttribute('data-ayn-rec-slot') || '0';
      var now = Date.now(), day = jstDay(now), src = recSrc(sec);
      var p = { ayn_rec_source: src, ayn_rec_target: g, ayn_rec_slot: slot, ayn_rec_date: day };
      recViewSend(sec);                                  /* 点得到就一定看得到:曝光没记上(懒加载 / 观察器没触发)就补一次 */
      send('ayn_rec_click', p);
      var id = recSecId(sec);
      if (!recClickedPv[id]) { recClickedPv[id] = 1; send('ayn_rec_click_pv', p); }
      var s = recLoad();
      s.p = s.p.filter(function (x) { return x && fresh(x.t, now, PEND_TTL_MS) && !(x.g === g && x.f === src); });
      s.p.unshift({ g: g, s: slot, f: src, d: day, t: now });
      s.p = s.p.slice(0, PEND_MAX);
      recSave(s);
    } catch (err) {}
  }
  try {
    document.addEventListener('click', recClick, true);
    document.addEventListener('auxclick', function (e) { if (e && e.button === 1) recClick(e); }, true);   /* 中键开新标签页 */
  } catch (e) {}

  /* 改车成功后写(赠品同步自己改车的事件不理:它只加减赠品行,理了反而在它改车途中插一次写车) */
  try {
    document.addEventListener('shopify:cart:lines-update', function (e) {
      var pr = e && e.promise;
      if (!pr || typeof pr.then !== 'function') return;
      if (e.detail && e.detail.source === 'ayunel-gift-sync') return;
      pr.then(function (res) {
        var d = res && res.detail;
        if (d && (d.didError || d.source === 'ayunel-gift-sync')) return;
        /* 改车刚成功 = 此刻 cookie 里的车服务端一定认:当场认下,不必再 GET 核。
           否则「没车的客人加购后马上跳页」:第一次打标时的车号要先核,跳页那一刻 GET 回包没人接 → 这页的推荐标记发不出去 */
        var t = cartToken();
        if (t && t !== cartBad) cartOk = t;
        recSync();
      }, function () {});
    }, true);
  } catch (e) {}

  /* 套装「一起加入购物车」成功后调(assets/ayunel-pdp-bundle.js):值 = 主商品>配套商品@配套颜色,同一辆车最多 8 组
     (2026-10-06 由 4 放宽:まとめ買い 一次最多 5 组,每个非当前款各一组;约 8×60 字,远低于车属性上限) */
  window.aynMarkBundle = function (mainId, pairedId, color) {
    try {
      var a = String(mainId || ''), b = String(pairedId || '');
      if (!isPid(a) || !isPid(b)) return;
      var m = a + '>' + b + '@' + String(color || '').replace(/[,:>@\s]/g, '').slice(0, 20);
      var s = recLoad();
      s.b = s.b.filter(function (e) { return !e || e.m !== m; });
      s.b.unshift({ m: m, t: Date.now(), c: '' });   /* 新的放前面:同一毫秒连加也留最新的;紧接着的 recSync 绑到刚加购成功的这辆车 */
      recSave(s);
      recSync();
    } catch (e) {}
  };

  recLanding();

  /* 曝光上报的唯一出口。点击处也会调它补发 —— 见下方 markView 的调用点。 */
  function markView(place) { sendOnce('ayn_trust_view_' + place, { ayn_place: place }); }

  /* ---------- 位置判定:显式 place 优先,URL 只作兜底 ----------
     ctx 是随机 block/section id,判不了位置;quick-add 弹窗里 URL 也不可靠。
     所以载体上显式标 data-ayn-trust-place,拿不到才退回 URL 猜。 */
  function placeOf(el) {
    var band = el && el.closest ? el.closest('[data-ayn-trust-place]') : null;
    var p = band && band.getAttribute('data-ayn-trust-place');
    if (p === 'pdp' || p === 'cart') return p;
    if (/^\/cart(\/|$|\?)/.test(location.pathname)) return 'cart';
    if (/^\/products\//.test(location.pathname)) return 'pdp';
    return 'other';
  }

  /* ---------- 信任标签:点击(同一个监听里先记自助退货入口)---------- */
  document.addEventListener('click', function (e) {
    /* 自助退货入口(2026-09-22 换主题遗漏排查 #8 补回):旧主题 snippets/ayunel-analytics.liquid 点任何
       a[href*="returns.ayunel.com"] 就发 ayn_returns_portal,新房没搬 ⇒ 9/18 起 GA4 里 0。事件名 / 参数名沿用旧版,
       每点一次记一次(次数口径,同旧版);page_type 的值改用本文件的 placeOf()(pdp / cart / other),不再是旧版的模板名 ——
       模板名在快速加购弹窗里会判错(同 2026-08-20 信任标签迁走的理由)。必须写在下面的早退之前。
       守卫 tests/test_theme_track_ready_queue.py TestReturnsPortalEvent。 */
    var portal = e.target && e.target.closest && e.target.closest('a[href*="returns.ayunel.com"]');
    if (portal) send('ayn_returns_portal', { page_type: placeOf(portal) });
    var btn = e.target.closest && e.target.closest('[data-ayn-trust-open]');
    if (!btn) return;
    var id = btn.getAttribute('data-ayn-trust-open') || '';
    var mod = id.indexOf('ayn-trust-return-') === 0 ? 'return'
            : id.indexOf('ayn-trust-fees-') === 0 ? 'fees' : null;
    if (!mod) return;                        /* 认不出的一律不记,宁缺勿错 */
    var place = placeOf(btn);
    /* 🔴 事件名里就把 模块 × 位置 拆开 —— GA4 事件列表里天然是 4 行,不可能被合并看 */
    /* 两个指标分开发,别让看报表的人去算:
       _* 结尾 = 每次点击(算「次数」)
       _u 结尾 = 每 session 只发一次(算「率」的分子 —— 有点击的**人**)
       🔴 GA4 的事件计数不是人数:同一个客人点 3 次就是 3 条。
          拿事件数 ÷ 会话数算率会虚高 —— 我们在加购数据上踩过(每加购会话平均 2.4-2.66 个事件)。
          所以口径固化在埋点里,不留给报表配置。 */
    /* 🔴 先补一次曝光再记点击。曝光 observer 只在 DOMContentLoaded 扫一次 DOM,
       而桌面端 quick-add 弹窗是把整块 .product-details(含本标签带)在那之后 morph 进来的
       → 那些节点永远不会被 observe:点击照记、曝光不记 = 分母漏、点击率虚高、甚至 >100%
       (2026-08-19 复审 P1-1)。点得到就一定看得到,所以在这里补发是安全且充分的,
       比加 MutationObserver 简单得多。sendOnce 保证一个 session 只算一次。 */
    markView(place);
    send('ayn_trust_' + mod + '_' + place, { ayn_module: mod, ayn_place: place });
    sendOnce('ayn_trust_' + mod + '_' + place + '_u', { ayn_module: mod, ayn_place: place });
    markCart('_ayn_trust_' + mod + '_' + place, '1');
  }, true);                                  /* capture:即使别的 handler 阻止冒泡也照记 */

  /* ---------- 曝光(分母):标签带 / 尺码诊断入口 ---------- */
  function observeViews() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        /* 露出一半 **或** 已占据半个视口高度,都算「看见了」 */
        var seen = en.intersectionRatio >= 0.5 ||
                   (en.intersectionRect && en.intersectionRect.height >= (window.innerHeight || 0) * 0.5);
        if (!seen) return;
        io.unobserve(en.target);
        if (en.target.hasAttribute('data-ayn-trust-place')) {
          markView(placeOf(en.target));
        } else {
          sendOnce('ayn_size_view', { ayn_place: placeOf(en.target) });
        }
      });
    }, { threshold: [0, 0.5] });
    /* 用 [0, 0.5] 两档:元素比视口还高时 ratio 永远到不了 0.5,
       只用 0.5 会让这类模块的曝光(= 点击率的分母)静默丢失(2026-08-19 复审 B3)。 */
    try {
      document.querySelectorAll('[data-ayn-trust-place]').forEach(function (el) { io.observe(el); });
      document.querySelectorAll('ayunel-size-diagnosis').forEach(function (el) { io.observe(el); });
    } catch (e) {}
  }
  /* ---------- 推荐区曝光(ayn_rec_view,见上方推荐位追踪)----------
     推荐区是懒加载(assets/product-recommendations.js:离屏幕 400px 才去取,取到后先置 data-recommendations-performed="true"
     再 morph 进卡片)。所以「在屏幕里」与「卡片已经渲染」两个条件各自会先到:观察器记下是否在屏幕里,
     卡片变化(MutationObserver)时再查一次;两个都满足才记,记过就停。推荐为空(没有卡片)永远不记。 */
  var REC_THRESHOLDS = [];
  for (var _ti = 0; _ti <= 50; _ti++) REC_THRESHOLDS.push(_ti / 50);
  function observeRec() {
    if (!('IntersectionObserver' in window)) return;
    var secs;
    try { secs = document.querySelectorAll('product-recommendations'); } catch (e) { return; }
    if (!secs || !secs.length) return;
    var inView = {};
    var mos = {};
    function tryView(sec) {
      var id = recSecId(sec);
      if (!inView[id] || recViewed[id]) return;
      if (sec.getAttribute('data-recommendations-performed') !== 'true') return;
      if (geomSeen(sec) === false) return;         /* 卡片进来后区块变高:观察器那次判定可能过时,以此刻几何为准(10/5 第四轮 Codex P2) */
      recViewSend(sec);                            /* 记过就停:见 recRelease */
    }
    recRelease = function (sec) {
      var id = recSecId(sec);
      try { io.unobserve(sec); } catch (e) {}
      try { if (mos[id]) mos[id].disconnect(); } catch (e) {}
      var wi = watching.indexOf(sec); if (wi >= 0) watching.splice(wi, 1);
    };
    /* 几何判:露出 ≥ 半个视口高,或露出 ≥ 自身一半(与观察器的判法同口径) */
    function geomSeen(sec) {   /* true / false;拿不到几何 = null(不知道,不拦) */
      if (!sec || typeof sec.getBoundingClientRect !== 'function') return null;
      try {
        var r = sec.getBoundingClientRect(), ih = window.innerHeight || 0;
        var vis = Math.min(r.bottom, ih) - Math.max(r.top, 0);
        return vis > 0 && (vis >= ih * 0.5 || (r.height > 0 && vis / r.height >= 0.5));
      } catch (e) { return false; }
    }
    /* 相交着、还没记曝光的推荐区:滚动 / 改尺寸时(每 200ms 至多一次)按几何再判 —— 固定阈值总有「停在两档之间」的空档(10/5 第三轮 Codex P2) */
    var watching = [], geomTimer = null;
    function geomCheck() {
      geomTimer = null;
      watching.slice().forEach(function (sec) {   /* 拷一份再遍历:tryView 记过会从 watching 里删自己,原数组遍历会跳过下一个(10/6 复审) */
        if (recViewed[recSecId(sec)] || geomSeen(sec) !== true) return;
        inView[recSecId(sec)] = true;
        tryView(sec);
      });
      watching = watching.filter(function (sec) { return !recViewed[recSecId(sec)]; });
    }
    function onScrollish() { if (watching.length && !geomTimer) geomTimer = setTimeout(geomCheck, 200); }
    try {
      window.addEventListener('scroll', onScrollish, { passive: true });
      window.addEventListener('resize', onScrollish, { passive: true });
    } catch (e) {}
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var sec = en.target, id = recSecId(sec);
        var seen = en.isIntersecting && (en.intersectionRatio >= 0.5 ||
                   (en.intersectionRect && en.intersectionRect.height >= (window.innerHeight || 0) * 0.5));
        inView[id] = !!seen;
        var i = watching.indexOf(sec);
        if (en.isIntersecting && !recViewed[id]) { if (i < 0) watching.push(sec); } else if (i >= 0) watching.splice(i, 1);
        if (seen) tryView(sec);
      });
    }, { threshold: REC_THRESHOLDS });
    /* 阈值要密(0.02 一档):推荐区比两个屏幕还高时相交比例永远到不了 0.5,只设 [0, 0.5] 就再也没有回调、「露出半屏高」那条兜底没机会判;
       0.1 一档也会停在两档之间漏判(10/5 双脑复审 Codex 两轮)。记过就 unobserve,回调只在看到之前发生。 */
    Array.prototype.forEach.call(secs, function (sec) {
      try {
        io.observe(sec);
        if (typeof MutationObserver === 'function') {
          var mo = new MutationObserver(function () {
            if (recViewed[recSecId(sec)]) { mo.disconnect(); io.unobserve(sec); return; }
            if (!inView[recSecId(sec)] && watching.indexOf(sec) >= 0 && geomSeen(sec) === true) inView[recSecId(sec)] = true;   /* 卡片进来、区块变高 */
            tryView(sec);
          });
          mo.observe(sec, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-recommendations-performed'] });
          mos[recSecId(sec)] = mo;
        }
      } catch (e) {}
    });
  }
  function observeAll() { observeViews(); try { observeRec(); } catch (e) {} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else { observeAll(); }

  /* ---------- 尺码诊断:接住它早就在发、却一直没人接的事件 ---------- */
  ['opened', 'diagnosed', 'applied', 'out_of_range', 'add_to_cart_fallback'].forEach(function (act) {
    document.addEventListener('ayunel:size:' + act, function (e) {
      var d = (e && e.detail) || {};
      send('ayn_size_' + act, {
        ayn_size: d.size || d.nearest_size || null,
        ayn_status: d.status || null,
        ayn_reason: d.reason || null,
        ayn_height_band: d.height_band || null,     /* 已 band 化,不是原值(隐私死律) */
        ayn_weight_band: d.weight_band || null,
        ayn_cup_adjusted: (d.cup_adjusted === true) ? 1 : 0,
        ayn_product: d.product_handle || null
      });
      /* 三層漏斗を注文側からも見えるようにする(小張 2026-08-19 追加要求:
         「診断を触った客の到達注文」vs「触っていない客」を比べたい)。
         GA だけだと注文の 17% を取りこぼす(死律4)ので、注文に印を持たせるのが唯一正確な道。 */
      if (act === 'opened') {
        /* 同 markView 的理由:quick-add 注入的诊断入口不会被 observe,补发保证分母不漏 */
        sendOnce('ayn_size_view', { ayn_place: placeOf(e && e.target) });
        sendOnce('ayn_size_opened_u', {});      /* 率の分子:開いた**人**(次数は ayn_size_opened) */
        markCart('_ayn_size_opened', '1');
      }
      if (act === 'diagnosed') markCart('_ayn_size_used', '1');     /* 推薦码まで見た */
      if (act === 'applied') markCart('_ayn_size_applied', String(d.size || '1')); /* その码で加購 */
    });
  });
})();
